import { SectionCard } from "../Domain";
import { ObligationDonut } from "./obligationDonut";
import { EmptyRow } from "./requirementIntelligenceParts";
import { OBLIGATION_STRENGTH_COPY, type DonutSlice } from "./utilities";

export interface ObligationStrengthProps {
    total: number;
    slices: DonutSlice[];
    modalTotal: number;
    takeaway: string;
}

export function ObligationStrengthSection({
    total,
    slices,
    modalTotal,
    takeaway,
}: ObligationStrengthProps) {
    return (
        <SectionCard
            headerLabel={OBLIGATION_STRENGTH_COPY.header}
            rightLabel={OBLIGATION_STRENGTH_COPY.right}
        >
            {total === 0 || modalTotal === 0 ? (
                <EmptyRow text={OBLIGATION_STRENGTH_COPY.emptyText} />
            ) : (
                <div className="grid gap-4 p-4 md:grid-cols-[220px_minmax(0,1fr)]">
                    <div className="flex items-center justify-center">
                        <ObligationDonut slices={slices} total={modalTotal} />
                    </div>
                    <div className="flex flex-col gap-3 min-w-0">
                        <ul className="flex flex-col gap-2">
                            {slices.map((slice) => {
                                const pct = (slice.count / modalTotal) * 100;
                                const pctLabel = pct < 1 ? "<1%" : `${Math.round(pct)}%`;
                                return (
                                    <li key={slice.key} className="flex items-center gap-3 min-w-0">
                                        <span
                                            className={`size-2.5 shrink-0 rounded-full ${slice.meta.dot}`}
                                        />
                                        <span className="flex-1 min-w-0 text-[12.5px] text-foreground break-words">
                                            {slice.meta.label}
                                        </span>
                                        <span className="w-10 text-right text-[12px] font-semibold text-foreground tabular-nums">
                                            {slice.count}
                                        </span>
                                        <span className="w-12 text-right text-[11px] text-muted-foreground tabular-nums">
                                            {pctLabel}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                        {takeaway && (
                            <p className="rounded-md border border-border bg-background/60 p-2.5 text-[12px] leading-relaxed text-foreground/90 break-words">
                                {takeaway}
                            </p>
                        )}
                    </div>
                </div>
            )}
        </SectionCard>
    );
}
